import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery
} from "@reduxjs/toolkit/query/react";
import { setAuthData } from "../slices/authSlice";
import { store } from "../store";

export const BASE_URL = process.env.REACT_APP_SERVER_URL + "/api/v1/";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    // Add the necessary headers for authentication
    const state: any = getState();
    const auth = state?.auth;
    if (auth?.accessToken) {
      headers.set("access-token", auth.accessToken);
      headers.set("token-type", "Bearer");
      headers.set("client", auth.client);
      headers.set("uid", auth.uid);
    }
    headers.set("Content-Type", "application/json");
    return headers;
  }
});

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions = {}) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 401) {
    store.dispatch(setAuthData({ accessToken: null, client: null, uid: null, user: null }));
    window.location.href = `/login?redirect=${encodeURIComponent(window.location.href)}`;
  }
  return result;
};

export const baseApi = createApi({
  keepUnusedDataFor: 0.0001,
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({})
});
